import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { City, LoginResponse, Restaurant } from "../../types";
import { PersistKey, SliceName } from "../../configs";

interface SessionState {
  admin?: LoginResponse;
  accessToken?: string;
  city?: City;
  restaurant?: Restaurant | null;
}

const initialState: SessionState = {};

export const sessionSlice = createSlice({
  name: SliceName.SESSION,
  initialState,
  reducers: {
    logout(state) {
      delete state.admin;
      delete state.accessToken;
      delete state.city;
      delete state.restaurant;
    },
    setAdmin(state, action: { payload: LoginResponse }) {
      state.admin = action.payload;
      if (action.payload.accessToken)
        state.accessToken = action.payload.accessToken;
    },
    setCity(state, action: { payload: City }) {
      state.city = action.payload;
    },
    setRestaurant(state, action: { payload: Restaurant | null }) {
      state.restaurant = action.payload;
    },
  },
});

export const sessionReducer = persistReducer(
  {
    key: PersistKey.SESSION,
    storage,
    whitelist: [
      "admin",
      "accessToken",
      "city",
      "restaurant",
    ] as (keyof SessionState)[],
  },
  sessionSlice.reducer
);

export const { logout, setAdmin, setCity, setRestaurant } =
  sessionSlice.actions;
